import { useState } from "react";
import { MainLayout } from "../components/layout/MainLayout";
import { Header } from "../components/layout/Header";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../components/ui/tabs";
import {
  Monitor,
  Settings,
  Printer,
  Users,
  ShoppingBag,
  Smartphone,
  Key,
  Receipt,
  PrinterIcon,
  TimerIcon,
  MonitorSmartphone,
  Watch,
} from "lucide-react";
import DisplaySetting from "../OutletSettings/DisplaySetting";
import OutletSettingCompo from "../OutletSettings/OutletSettingCompo";
import KotPrint from "../OutletSettings/KotPrint";
import CustomerSetting from "../OutletSettings/CustomerSetting";
import PetPoojaSetting from "../OutletSettings/PetPoojaSetting";
import PhonePeSetting from "../OutletSettings/PhonePeSetting";
import ApiKeySetting from "../OutletSettings/ApiKeysSettings";
import TaxOptions from "../OutletSettings/TaxOptions";
import PrinterOptions from "../OutletSettings/PrinterOptions";
import ConfigDevice from "../OutletSettings/ConfigDevice";
import OperationalTimings from "../OutletSettings/OperationalTimings";
import PabblySetting from "../OutletSettings/PabblySetting";

export default function OutletSettings() {
  const [activeTab, setActiveTab] = useState("display");

  const tabs = [
    {
      key: "display",
      label: "Display",
      icon: Monitor,
      component: DisplaySetting,
    },
    {
      key: "outlet",
      label: "Outlet Setting",
      icon: Settings,
      component: OutletSettingCompo,
    },
    {
      key: "time",
      label: "Time Setting",
      icon: TimerIcon,
      component: OperationalTimings,
    },
    {
      key: "whatapp",
      label: "Whatapp Setting",
      icon: Watch,
      component: PabblySetting,
    },
    {
      key: "kot",
      label: "KOT Print",
      icon: Printer,
      component: KotPrint,
    },
    {
      key: "customer",
      label: "Customer Settings",
      icon: Users,
      component: CustomerSetting,
    },
    {
      key: "petpooja",
      label: "PetPooja Settings",
      icon: ShoppingBag,
      component: PetPoojaSetting,
    },
    {
      key: "phonepe",
      label: "Payment Settings",
      icon: Smartphone,
      component: PhonePeSetting,
    },
    {
      key: "apikeys",
      label: "Platform API Keys",
      icon: Key,
      component: ApiKeySetting,
    },
    {
      key: "tax",
      label: "Tax Options",
      icon: Receipt,
      component: TaxOptions,
    },
    {
      key: "printer",
      label: "Printer Options",
      icon: PrinterIcon,
      component: PrinterOptions,
    },
    {
      key: "configdevice",
      label: "Config Device",
      icon: MonitorSmartphone,
      component: ConfigDevice,
    },
  ];

  return (
    <MainLayout>
      <Header
        title="Outlet Settings"
        subtitle="Configure your restaurant outlet preferences and integrations"
      />

      <div className="p-6">
        <Tabs
          value={activeTab}
          onValueChange={setActiveTab}
          className="space-y-6"
        >
          {/* Horizontal Tab Navigation */}
          <div className="border-b border-border overflow-x-auto">
            <TabsList className="inline-flex h-auto p-0 bg-transparent w-full justify-start">
              {tabs.map((tab) => {
                const Icon = tab.icon;
                return (
                  <TabsTrigger
                    key={tab.key}
                    value={tab.key}
                    className="relative h-auto py-3 px-4 rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:shadow-none hover:bg-muted/50 transition-colors"
                  >
                    <div className="flex items-center gap-2">
                      <Icon className="w-4 h-4" />
                      <span className="whitespace-nowrap">{tab.label}</span>
                    </div>
                  </TabsTrigger>
                );
              })}
            </TabsList>
          </div>

          {/* Tab Content */}
          <div className="rounded-xl border border-border bg-card">
            {tabs.map((tab) => {
              const Component = tab.component;
              return (
                <TabsContent key={tab.key} value={tab.key} className="mt-0 p-6">
                  <Component />
                </TabsContent>
              );
            })}
          </div>
        </Tabs>
      </div>
    </MainLayout>
  );
}
